const SvgExpandLess = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' {...props}>
      <path d='M12 8.297l-6 6 1.41 1.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6z' fill='currentColor' />
    </svg>
  );
};

export default SvgExpandLess;
